import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "orders" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"width":"100%","margin-left":"2rem"} }
const _hoisted_5 = { style: {"margin":"0","font-size":"2.5rem"} }
const _hoisted_6 = { class: "order-items" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  style: {"font-size":"3rem","padding":"1rem","height":"unset"}
}

import store from '@/store'
import * as database from '@/services/database'
import { ref } from 'vue'
import { Order } from '@/store/Order'
 

export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersView',
  setup(__props) {

const orders = ref<Order[]>([])

database.syncOrders(dbOrders => {
  orders.value = dbOrders
})

const process = (order: Order) => {
  database.setOrderProcessed(order.id)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(store).state.loadingUsers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value, (order) => {
            return (_openBlock(), _createElementBlock("div", {
              key: order.id,
              class: _normalizeClass(["order", {'order-processed': !!order.processed}])
            }, [
              _createElementVNode("img", {
                src: _unref(store).getUser(order.userId)?.photo,
                style: {"width":"20rem","border-radius":"1rem"}
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(store).getUser(order.userId).name), 1),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("b", null, _toDisplayString(item.quantity), 1),
                      _createTextVNode(" x " + _toDisplayString(item.name), 1)
                    ]))
                  }), 128))
                ])
              ]),
              (!order.processed)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    style: {"font-size":"3rem","padding":"1rem","height":"unset"},
                    onClick: ($event: any) => (process(order))
                  }, "Fertig", 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("button", _hoisted_8, "Fertig✓"))
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})